export type LegalDocument = {
  title: string
  updatedLabel: string
  sections: { heading: string; paragraphs: string[] }[]
}

export const privacyPolicy: LegalDocument = {
  title: 'Política de Privacidad',
  updatedLabel: 'Última actualización: este año',
  sections: [
    {
      heading: '1. Información que recopilamos',
      paragraphs: [
        'Este sitio puede recopilar información técnica no identificable de forma directa, como el tipo de navegador, el sistema operativo, la ubicación aproximada derivada de la dirección IP y las páginas visitadas dentro del sitio.',
        'No solicitamos ni almacenamos historiales médicos, diagnósticos ni información clínica de los visitantes.',
      ],
    },
    {
      heading: '2. Uso de la información',
      paragraphs: [
        'La información recopilada se utiliza únicamente con fines estadísticos, para medir el rendimiento del contenido editorial y mejorar la experiencia de lectura.',
        'No vendemos ni alquilamos la información de los visitantes a terceros.',
      ],
    },
    {
      heading: '3. Cookies y tecnologías similares',
      paragraphs: [
        'Utilizamos cookies y píxeles de medición para entender cómo se navega el sitio y para atribuir visitas provenientes de campañas publicitarias. Puedes desactivar las cookies desde la configuración de tu navegador; algunas secciones podrían dejar de funcionar correctamente.',
      ],
    },
    {
      heading: '4. Contenido de terceros',
      paragraphs: [
        'Algunas secciones enlazan a sitios administrados por terceros. Una vez que abandonas este sitio, la información que compartas queda regida por las políticas de privacidad de esos terceros, sobre las cuales no tenemos control.',
      ],
    },
    {
      heading: '5. Menores de edad',
      paragraphs: [
        'El contenido de este sitio está dirigido a personas mayores de 18 años. No recopilamos intencionalmente información de menores.',
      ],
    },
  ],
}

export const termsOfUse: LegalDocument = {
  title: 'Términos de Uso',
  updatedLabel: 'Última actualización: este año',
  sections: [
    {
      heading: '1. Naturaleza del contenido',
      paragraphs: [
        'Todo el contenido publicado en este sitio tiene carácter informativo y educativo. No constituye asesoramiento médico, nutricional, psicológico ni de ningún otro tipo profesional.',
        'Los nombres, casos y testimonios presentados pueden ser ilustrativos y utilizarse con fines editoriales para explicar conceptos generales.',
      ],
    },
    {
      heading: '2. Resultados individuales',
      paragraphs: [
        'Los resultados descritos son individuales y no deben interpretarse como una promesa, garantía o resultado típico. Cada persona responde de forma distinta a cambios en su alimentación o estilo de vida.',
      ],
    },
    {
      heading: '3. Uso aceptable',
      paragraphs: [
        'Está prohibido reproducir, redistribuir o modificar el contenido de este sitio con fines comerciales sin autorización previa por escrito.',
        'El visitante se compromete a no utilizar el sitio para actividades ilícitas, fraudulentas o que puedan afectar su funcionamiento.',
      ],
    },
    {
      heading: '4. Enlaces y ofertas de terceros',
      paragraphs: [
        'Este sitio puede contener enlaces a productos o programas de terceros. Las condiciones de compra, entrega, garantías y devoluciones son responsabilidad exclusiva del proveedor correspondiente.',
      ],
    },
    {
      heading: '5. Limitación de responsabilidad',
      paragraphs: [
        'En la máxima medida permitida por la ley, este sitio no será responsable por daños directos o indirectos derivados del uso, o de la imposibilidad de uso, de la información aquí publicada. Consulta siempre a un profesional de la salud antes de iniciar cualquier cambio en tu alimentación.',
      ],
    },
    {
      heading: '6. Cambios en los términos',
      paragraphs: [
        'Podemos actualizar estos términos en cualquier momento. El uso continuado del sitio después de una actualización implica la aceptación de la versión vigente.',
      ],
    },
  ],
}
